import styled from 'styled-components'

const ResultsContainer = styled.div`
	margin-top: 20px;
`
export { ResultsContainer }
